"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var xmlbuilder_1 = __importDefault(require("xmlbuilder"));

var save_file_1 = __importDefault(require("save-file"));

var XmlWriter =
/** @class */
function () {
  function XmlWriter(rootName, rootAttrs) {
    var _this = this;

    this.root = xmlbuilder_1.default.create(rootName, {
      encoding: "utf-8"
    });

    if (rootAttrs) {
      lodash_1.forOwn(rootAttrs, function (value, name) {
        _this.root.att(name, value);
      });
    }
  }

  XmlWriter.prototype.element = function (name, content, attrs) {
    var _a;

    content = content === undefined ? "" : content;
    var el = this.root.ele((_a = {}, _a[name] = content, _a));

    if (attrs) {
      lodash_1.forOwn(attrs, function (value, name) {
        el.att(name, value);
      });
    }
  };

  XmlWriter.prototype.toString = function () {
    return this.root.end({
      pretty: true
    });
  };

  XmlWriter.prototype.saveAs = function (filename) {
    var _this = this;

    return new Promise(function (res, rej) {
      try {
        save_file_1.default(new Blob([_this.toString()], {
          type: "text/plain;charset=utf-8"
        }), filename);
        res();
      } catch (err) {
        rej(err);
      }
    });
  };

  return XmlWriter;
}();

exports.XmlWriter = XmlWriter;